/* globals Class */
var h = require('virtual-dom/h');
var createElement = require('virtual-dom/create-element');

var BaseDialog = require('./base_dialog');

var render = function(publishedUrl, contentType, showUrl) {
  var url = showUrl ?
    h('a .publish-success-url', {href: publishedUrl, target: '_blank'}, publishedUrl) :
    '';

  var tip = showUrl ?
    h('.modal-panel-tip', [
      h('.heads-up-icon .svg-ico-lightbulb'),
      h('p .publish-copy', [
        h('span .publish-label', 'Note: '),
        'Clear your cache or do a hard refresh if you don\'t see',
        h('br'),
        'your changes on the republished ' + contentType.toLowerCase() + '. '
      ])
    ]) :
    '';

  return createElement(
    h('.modal-content-container.success-container', [
      h('.publish-success-header', [
        h('.publish-icon.publish-success-icon .fa .fa-check'),
        h('.publish-label .success', 'Success!'),
        url
      ]),
      h('.modal-panel-description', ['Feel free to browse away from here to keep working in',
                                     h('br'),
                                     'Unbounce, or stick around and you\'ll be able to continue',
                                     h('br'),
                                     'editing once republishing is complete.'
                                    ]),
      tip
    ])
  );
};

var PublishSuccessDialog = Class.create(BaseDialog, {
  initialize: function($super, options) {
    this.contentType = options.contentType;
    this.showUrl = options.showUrl;
    this.publishedUrl = options.mainPage.page.published_url || '';

    var self = this;

    options = {
      clickOutsideWillClose: false,
      allowHeader: true,
      closeX: true,
      attributes: {
        className: 'modal-panel modal-panel-success' + (this.showUrl ? '' : ' no-url')
      },
      actions: [{
        attributes: {
          id: 'close',
          className: 'flat-btn flat-btn-close flat-btn-with-icon push-left action button modal-button'
        },
        type: 'button',
        label: 'Done',
        action: function() {
          self.close();
        }
      }]
    };

    $super(options);
  },

  installUI: function($super) {
    $super();

    this.setTitle('Your changes are live!');
    this.setContent(render(this.publishedUrl, this.contentType, this.showUrl));
  }
});

module.exports = PublishSuccessDialog;



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/publish/publish_success.js